import React, { createContext, useContext, useState, useCallback } from 'react';

const ChatContext = createContext();

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

export const ChatProvider = ({ children }) => {
  const [chatMessages, setChatMessages] = useState(() => {
    // Load from localStorage on initialization
    const saved = localStorage.getItem('evaChatMessages');
    return saved ? JSON.parse(saved) : [];
  });
  const [message, setMessage] = useState('');
  const [chatPanelWidth, setChatPanelWidth] = useState(() => {
    const saved = localStorage.getItem('evaChatPanelWidth');
    return saved ? parseInt(saved, 10) : 350;
  });

  // Save to localStorage whenever chatMessages changes
  React.useEffect(() => {
    localStorage.setItem('evaChatMessages', JSON.stringify(chatMessages));
  }, [chatMessages]);

  // Save chatPanelWidth to localStorage
  React.useEffect(() => {
    localStorage.setItem('evaChatPanelWidth', chatPanelWidth.toString());
  }, [chatPanelWidth]);

  const addMessage = useCallback((newMessage) => {
    setChatMessages(prev => [...prev, newMessage]);
  }, []);

  const updateMessage = useCallback((messageId, updates) => {
    setChatMessages(prev => prev.map(msg => 
      msg.id === messageId ? { ...msg, ...updates } : msg
    ));
  }, []);

  const clearMessages = useCallback(() => {
    setChatMessages([]);
    localStorage.removeItem('evaChatMessages');
  }, []);

  const value = {
    chatMessages,
    setChatMessages,
    message,
    setMessage,
    chatPanelWidth,
    setChatPanelWidth,
    addMessage,
    updateMessage,
    clearMessages,
  };

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

